import { publicEnvConfig } from 'helpers/env';

export const redirect = (url) => (window.location = url);

export const redirectToRailsPage = (url) => redirect(`${publicEnvConfig.RELATIVE_BASE_URL}${url}`);
